export const dashboard = {
  vehicles: "Vehicles",
  drivers: "Drivers",
  updateTime: "Last Update: {date}",
  today: "Today",
  lastWeek: "Last 7 Days",
  lastMonth: "Last 30 Days",
  refresh: "Refresh",
  noData: "@:common.global.noData",
  fleetSelect: {
    allFleets: "All Fleets",
    empty: "None Selected",
    totalVehicles: "Total Vehicles",
  },
  vehicleUsage: {
    customRange: "Custom Range",
    titleCustomRange: "Custom Range: {startDate} - {endDate}",
    titleLast30Days: "Last 30 Days Usage",
    titleLast7Days: "Last 7 Days Usage",
    titleTodayUsage: "Today's Usage",
    vehicleUsage: "Vehicle Usage",
    todaysAvg: "Today's Avg.",
    lastWeeksAvg: "Last 7 Days Avg.",
    lastMonthsAvg: "Last 30 Days Avg.",
    exp: "Expected Avg.",
    actualUsage: "Actual",
    failedToGetVehicleUsageData:
      "Failed to get vehicle usage data. Refresh to try again.",
  },
  inspectionStats: {
    inspectionStats: "Inspection Stats of Current Cycle",
    expectedInspections: "Expected Inspections",
    uninspected: "Uninspected",
    criticalItemFailed1OrMore: "Critical Item Failed (1 or more)",
    nonCriticalItemFailed1OrMore: "Non-Critical Item Failed (1 or more)",
    passed: "Passed",
    submissionTips:
      "The submission % refers to the actual number of vehicles with inspection reports submitted over the total number of vehicles in current inspection cycle which is based on the inspection settings of each fleet.",
    numberOfSubmittedReports: "Number of Submitted Reports",
    totalNumberOfVehiclesOperated: "Total Number of Vehicles Operated",
    reliabilityTips:
      "The reliability % refers to the number of passed items over the total number of inspection items for all submitted reports.",
    numberOfPassedItems: "Number of Passed Items",
    totalNumberOfInspectionItems: "Total Number of Inspection Items",
    rank: "Rank",
    vehicleID: "Vehicle ID",
    expected: "Expected",
    submitted: "Submitted",
    submission: "Submission",
    criticalItemFailed: "Critical Item Failed",
    nonCriticalItemFailed: "Non-Critical Item Failed",
    reliability: "Reliability",
    failedToGetInspectionStatsData:
      "Failed to get inspection stats data. Refresh to try again.",
    inspectedVehicles: "Inspected Vehicles",
    reportsSubmitted: "Reports Submitted",
    numberOfInspectedVehicles:
      "Number of Vehicles with Inspection Reports Submitted",
    numberOfTotalVehicles: "Total Number of Vehicles",
  },
  alertsStats: {
    subtotal: "Subtotal",
    alertsStats: "Alert Stats",
    avgPerVehicle: "Avg. Per Vehicle",
    rank: "Rank",
    driverName: "Driver",
    vehicleID: "Vehicle ID",
    DSS: "DSS",
    PDCritical: "PD - Critical",
    cameraBlocked: "Camera Blocked",
    unauthorizedDrivers: "Unauthorized Drivers",
    geofencing: "Geofencing",
    speeding: "Speeding",
    total: "Total",
    fatigue: "Fatigue",
    phoneUsage: "Phone Usage",
    smoking: "Smoking",
    front: "Front",
    rear: "Rear",
    left: "Left",
    right: "Right",
    enter: "Enter",
    exit: "Exit",
    seatbelt: "SeatBelt Unfastened",
    FailedToGetAlertsStatsData:
      "Failed to get alerts stats data. Refresh to try again.",
    hardHatOff: "Hardhat Off",
  },
  rankingByDriver: {
    rankingByDriver: "Ranking by Driver",
    rank: "Rank",
    driverName: "Driver",
    alerts: "Alerts",
    hoursDriven: "Hours Driven",
    failedToGetRankingByDriverData:
      "Failed to get ranking by driver data. Refresh to try again.",
  },
  rankingByVehicle: {
    rankingByVehicle: "Ranking by Vehicle",
    rank: "Rank",
    vehicleID: "Vehicle ID",
    usage: "Usage",
    submission: "Submission",
    reliability: "Reliability",
    alerts: "Alerts",
    failedToGetRankingByVehiclesData:
      "Failed to get ranking by vehicles data. Refresh to try again.",
  },
  noFleet: {
    noFleetTips:
      "No fleets have been created yet. Create one to get started. | No fleets have been created yet. No information available.",
    noVehicleTips:
      "No vehicles have been created yet. Create one to get started. | No vehicles have been created yet. No information available.",
    createNow: "Create Now",
  },
  export: {
    export: "Export",
    confirmDateRangeForExport: "Confirm the Date Range for Export",
    summary: "Summary",
    vehicles: "@:dashboard.vehicles",
    drivers: "'@:dashboard.drivers",
    alerts: "@:dashboard.rankingByVehicle.alerts",
    fleetName: "@:common.fleet.fleetName",
    timeRanges: "Time Range",
    fromTo: "From {0} To {1}",
    numberOfDays: "Number of Days",
    totalVehicles: "Total Vehicles",
    driverSafetySystem: "@:common:device.driverSafetySystem",
    pedestrianDetection: "@:dashboard.alertsStats.PDCritical",
    maximumUsage: "Maximum Usage (Hrs)",
    vehicleUsage: "Vehicle Usage (Hrs)",
    utilizationRate: "Utilization Rate (%)",
    expectedUsage: "Expected Usage (Hrs)",
    expectedUtilizationRate: "Expected Utilization Rate (%)",
    inspectionTemplate: "@:nav.inspectionReports",
    inspection: "@:nav.inspection",
    fleet: "@:common.vehicle.fleet",
    totalAlerts: "Total Alerts",
  },
};
